import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeHouseholdSetupFeatureUnsubscribeSuccessModule } from './../lib/se-household-setup-feature-unsubscribe-success.module'
import { UnsubscribeSuccessDocsComponent } from './unsubscribe-success-docs/unsubscribe-success-docs.component'

@NgModule({
  declarations: [UnsubscribeSuccessDocsComponent],
  exports: [UnsubscribeSuccessDocsComponent],
  imports: [
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeHouseholdSetupFeatureUnsubscribeSuccessModule
],
})

export class SeHouseholdSetupFeatureUnsubscribeSuccessDocsModule {}
